import React, { createContext, useContext, useReducer, useRef } from 'react';
import type { Mutation } from './mutations';
import { reducer } from './mutations';
import { type Computed, useComputed } from './computed';
import type { State } from './types';

export interface OrgStore {
  loaded: LoadedRefs;
  state: State;
  dispatch: React.Dispatch<Mutation>;
  computed: Computed;
}

export type LoadedRefs = Record<keyof State, React.MutableRefObject<boolean>>;

const OrgContext = createContext<OrgStore>({} as OrgStore);

export function OrgStoreProvider({
  children,
}: {
  children: React.ReactElement;
}) {
  const initialState: State = {
    campuses: { data: {}, loaded: false },
    ministries: { data: [], loaded: false },
    entities: { data: {}, loaded: false },
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const loaded: LoadedRefs = {
    campuses: useRef(false),
    ministries: useRef(false),
    entities: useRef(false),
  };
  const props: OrgStore = {
    loaded,
    state,
    dispatch,
    computed: {} as Computed,
  };
  props.computed = useComputed(props);

  return React.createElement(OrgContext.Provider, { value: props }, children);
}

export function useOrgStore() {
  return useContext(OrgContext);
}
